import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
} from "@mui/material";
import { tableHeaderStyles, tableCellStyles } from "../../../../utils/styles";

const DocumentsSkeleton: React.FC = () => (
  <TableContainer component={Paper}>
    <Table size="small">
      <TableHead>
        <TableRow>
          <TableCell {...tableHeaderStyles}>File</TableCell>
          <TableCell {...tableHeaderStyles}>Category</TableCell>
          <TableCell {...tableHeaderStyles}>Size</TableCell>
          <TableCell {...tableHeaderStyles}>Uploaded On</TableCell>
          {/* <TableCell {...tableHeaderStyles}>Actions</TableCell> */}
        </TableRow>
      </TableHead>
      <TableBody>
        {[...Array(3)].map((_, index) => (
          <TableRow key={index}>
            <TableCell {...tableCellStyles}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Skeleton variant="circular" width={20} height={20} />
                <Box>
                  <Skeleton variant="text" width={140} height={16} />
                  <Skeleton variant="text" width={100} height={14} />
                </Box>
              </Box>
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Skeleton
                variant="rectangular"
                width={80}
                height={20}
                sx={{ borderRadius: 1 }}
              />
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Skeleton variant="text" width={60} height={16} />
            </TableCell>
            <TableCell {...tableCellStyles}>
              <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <Skeleton variant="circular" width={24} height={24} />
                <Skeleton variant="text" width={120} height={16} />
              </Box>
            </TableCell>
            {/* <TableCell {...tableCellStyles}>
              <Skeleton variant="circular" width={24} height={24} />
            </TableCell> */}
          </TableRow>
        ))}
      </TableBody>
    </Table>
  </TableContainer>
);

export default DocumentsSkeleton;
